<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<h1><a id="page_32"></a><a href="#/005toc#part1">01<br/>APPETIZERS &amp; HORS D’OEUVRES</a></h1>
<p class="noindent"><a id="page_33"></a><strong>Appetizers are small dishes or bite-size food served before a meal or at a cocktail party with drinks. Hors d’oeuvres are hot or cold savory bites and are also considered party food. Small plates should be provided, along with napkins.</strong></p>
<p class="noindent-space1"><strong>Chicken appetizers are generally hearty and fun to serve. The most popular may be chicken wings. In this chapter you will find several wing recipes, such as Hot and Sweet Chili Wings, Asian Style; Baked Chicken Wings in Honey-Soy Glaze; and Spicy Chicken Wings with Blue Cheese Dressing.</strong></p>
<p class="noindent-space1"><strong>Other delicious chicken appetizers here include Chicken Quesadillas, Easy Grilled Drummettes, and Herbed Chicken Cocktail Bites.</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008-part01.vue?6da4e6e0